import React, { useState, useEffect } from "react";
import { ref, get, update } from "firebase/database";
import { db } from "../firebaseConfig";
import './style/AddOns.css';

const AddOns = () => {
  const [workspaces, setWorkspaces] = useState({});
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [workspaceData, setWorkspaceData] = useState({
    appMenu: false,
    campaigns: false,
    customerSatisfaction: false,
    documents: false,
    powerDevices: false,
    questionnaires: false,
  });

  const handleSelectChange = async (e) => {
    const workspaceKey = e.target.value;
    setSelectedWorkspace(workspaceKey);

    const workspaceAddOnsRef = ref(db, `neoslide/addOns/${workspaceKey}`);
    const snapshot = await get(workspaceAddOnsRef);

    if (snapshot.exists()) {
      const selectedWorkspaceData = snapshot.val();
      setWorkspaceData({
        appMenu: selectedWorkspaceData.appMenu ?? false,
        campaigns: selectedWorkspaceData.campaigns ?? false,
        customerSatisfaction: selectedWorkspaceData.customerSatisfaction ?? false,
        documents: selectedWorkspaceData.documents ?? false,
        powerDevices: selectedWorkspaceData.powerDevices ?? false,
        questionnaires: selectedWorkspaceData.questionnaires ?? false,
      });
    } else {
      setWorkspaceData({
        appMenu: false,
        campaigns: false,
        customerSatisfaction: false,
        documents: false,
        powerDevices: false,
        questionnaires: false,
      });
    }
  };

  const handleSwitchChange = (key) => {
    setWorkspaceData({
      ...workspaceData,
      [key]: !workspaceData[key],
    });
  };

  const handleSubmit = async () => {
    try {
      const workspaceRef = ref(db, `neoslide/addOns/${selectedWorkspace}`);
      await update(workspaceRef, workspaceData);
      alert("Addons updated successfully!");
    } catch (error) {
      console.error("Error updating Addons:", error);
    }
  };

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const workspacesRef = ref(db, "neoslide/workspaces");
        const snapshot = await get(workspacesRef);

        if (snapshot.exists()) {
          const fetchedWorkspaces = snapshot.val();
          setWorkspaces(fetchedWorkspaces);
        }
      } catch (error) {
        console.error("Error fetching workspaces:", error);
      }
    };

    fetchWorkspaces();
  }, []);

  return (
    <div className="workspaces-container">
      <h2>Add Ons</h2>
      <select onChange={handleSelectChange} value={selectedWorkspace || ""}>
        <option value="" disabled>
          Select a workspace
        </option>
        {Object.entries(workspaces).map(([key, name]) => (
          <option key={key} value={name}>
            {name}
          </option>
        ))}
      </select>
      {workspaceData && selectedWorkspace && (
        <div className="workspace-details">
          <h3>{selectedWorkspace} Details</h3>
          <form className="checkbox-form">
            {Object.keys(workspaceData).map((key) => (
              <div key={key} className="checkbox">
                <label>{key}</label>
                <input
                  className="checkbox-input"
                  type="checkbox"
                  checked={workspaceData[key]}
                  onChange={() => handleSwitchChange(key)}
                />
              </div>
            ))}
          </form>
          <button onClick={handleSubmit}>Submit Changes</button>
        </div>
      )}
    </div>
  );
};

export default AddOns;
